import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicInquietude = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Sécurité et accessibilité', link: '/topics/securite'},
    { label: 'Questions de sécurité', link: '/topics/securite/question-securite'},
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Vous aviez hâte de réserver votre compétition, mais vous doutez soudain de votre choix.
            </p>
            <p className="help-text">
              Commencez par lire toutes les informations contenues dans la description de la compétition, comme le contenu des WODs, les niveaux et standards demandés, 
              le règlement intérieur s'il est présent.
            </p>
            <p className="help-text">
              Vous hésitez toujours ? Contactez votre organisateur pour en savoir plus. Conseil important : consultez les conditions d'annulation, et conditions 
              générales sur la compétition avant de réserver.
            </p>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicInquietude